import { Component, ElementRef, Inject, NgZone, PLATFORM_ID, TransferState } from '@angular/core';

import {
  DxScrollViewComponent,
  DxTemplateHost,
  IterableDifferHelper,
  NestedOptionHost,
  WatcherHelper,
} from 'devextreme-angular';

@Component({
  standalone: true,
  selector: 'abc-scroll-view',
  template: '<ng-content></ng-content>',
  providers: [DxTemplateHost, WatcherHelper, IterableDifferHelper, NestedOptionHost],
})
export class _AbcScrollViewComponent extends DxScrollViewComponent {
  constructor(
    elementRef: ElementRef,
    ngZone: NgZone,
    templateHost: DxTemplateHost,
    _watcherHelp: WatcherHelper,
    optionHost: NestedOptionHost,
    transferState: TransferState,
    @Inject(PLATFORM_ID) platformId: any
  ) {
    super(elementRef, ngZone, templateHost, _watcherHelp, optionHost, transferState, platformId);
  }
}
